import { render, staticRenderFns } from "./etiquetas.vue?vue&type=template&id=89bff3de&scoped=true"
import script from "./etiquetas.vue?vue&type=script&lang=js"
export * from "./etiquetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bff3de",
  null
  
)

export default component.exports